if(location.pathname.includes('login')){
	for(let item of document.getElementsByTagName('h4')){
		if(item.innerText.includes('ERPNext')){
			item.innerText = item.innerText.replace('ERPNext','ERP Beplus');
		}
	}
}